import { AccomodationTranslationDto } from "./accomodation-translation.dto";
import { CardInfoTranslationDto } from "./card-info-translation.dto";
export class AccomodationFirstChildrenDto {
   /*
   *
   */
    constructor(
        public accomodation?: AccomodationTranslationDto,
        public otherActiveAccomodation?: number, 
        public children?:CardInfoTranslationDto[]
    ){}
    
}